import { FormGroupJson } from "../../../../tools/api/forms/useServerJsonForm";

export function getAllFormElements(formGroups: FormGroupJson[]) {
   return formGroups.flatMap(formGroup => formGroup.formElements ?? []);
}
